import axiosInstance from "services/common/axiosInstance";

const handleRequest = async (promise: Promise<any>) => {
  try {
    const response = await promise;
    return response.data;
  } catch (error: any) {
    throw error?.response?.data || error.message;
  }
};

const BASE_URL = "/faq";

export const listfaqquestionadmin = (data: any) =>
  handleRequest(axiosInstance.post(`${BASE_URL}/listfaqquestion_admin`, data));

export const addfaqcategory = (data: any) =>
    handleRequest(axiosInstance.post(`${BASE_URL}/addnewfaqcategory`, data));

export const updatefaqcategory = (category_id: number, data: any) =>
    handleRequest(axiosInstance.put(`${BASE_URL}/updatefaqcategory`, data, { params: { category_id}}));

export const listfaqcategoryadmin = () =>
    handleRequest(axiosInstance.get(`${BASE_URL}/listfaqcategoryadmin`));

export const addfaqquestion = (data: any) =>
    handleRequest(axiosInstance.post(`${BASE_URL}/addnewfaqquestion`, data));

export const updatefaqquestion = (question_id: number, data: any) =>
    handleRequest(axiosInstance.put(`${BASE_URL}/updatefaqquestion`, data, {params: {question_id}}));

export const deletefaqquestion = (question_id: number) =>
    handleRequest(axiosInstance.delete(`${BASE_URL}/deletefaqquestion`, { params: {question_id}} ));
